export default "__VITE_ASSET__9858f6d9__"